import { oldSignOutPath } from 'auth/routes/routePaths';
import { IAuthForm, IAuthUser } from 'auth/types';
import { LocalStorageKeys } from 'core/enums';
import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { goTo, localStorage } from 'core/utils';

const ACTION_SIGN_IN_SSO = 'authenticate_sso';

export const getAuthUser = async (signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get('/auth/user/logged-user', signal);

  return mapRecordFromServer<IAuthUser>(data.user);
};

export const signIn = async (data: IAuthForm) =>
  partfinitiClient.postForm('/auth/standard/sign-in', data);

export const signOut = () => {
  localStorage.remove(LocalStorageKeys.LOGGED_USER);

  goTo(oldSignOutPath());
};

export const ssoSignIn = async (data: Record<string, unknown>) =>
  partfinitiClient.postForm('/auth/standard/sign-in', {
    signinAction: ACTION_SIGN_IN_SSO,
    ...data,
  });

export const impersonate = async (data: Record<string, unknown>) =>
  partfinitiClient.postForm('/auth/index/impersonate', data);
